var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import CryptoJS from 'crypto-js';
/**
 * Hash SHA256 para dados sensíveis (GDPR compliant)
 */
var hashData = function (data) {
    if (!data)
        return '';
    return CryptoJS.SHA256(data.toLowerCase().trim()).toString();
};
/**
 * 🎯 DISPARA CONVERSÃO QUALIFICADA PARA FACEBOOK ADS
 * Usa Google Tag Manager DataLayer + Facebook Pixel
 *
 * @param userData - Dados do usuário para Advanced Matching
 */
export var trackQualifiedLead = function (userData) {
    if (typeof window === 'undefined')
        return;
    // ✅ PREPARAR DADOS HASHED PARA FACEBOOK
    var hashedData = {};
    if (userData.email) {
        hashedData.em = hashData(userData.email);
    }
    if (userData.firstName) {
        hashedData.fn = hashData(userData.firstName);
    }
    if (userData.lastName) {
        hashedData.ln = hashData(userData.lastName);
    }
    if (userData.phone) {
        var cleanPhone = userData.phone.replace(/\D/g, '');
        hashedData.ph = hashData(cleanPhone);
    }
    if (userData.userId) {
        hashedData.external_id = userData.userId;
    }
    // 🔥 País (Brasil)
    hashedData.country = hashData('br');
    // ✅ 1. DISPARAR VIA GOOGLE TAG MANAGER (DataLayer)
    if (window.dataLayer) {
        window.dataLayer.push({
            event: 'qualifiedLead', // Nome do evento no GTM
            user_data: hashedData, // Dados hasheados para Advanced Matching
            event_category: 'conversion',
            event_label: 'primeira_conexao',
            value: 0.00,
            currency: 'BRL'
        });
        /* console.log('✅ GTM DataLayer: qualifiedLead pushed', {
          event: 'qualifiedLead',
          parametros: Object.keys(hashedData)
        });*/
    }
    // ✅ 2. DISPARAR DIRETO VIA FACEBOOK PIXEL (fallback)
    if (window.fbq) {
        var eventID = "lead_".concat(Date.now(), "_").concat(Math.random().toString(36).substring(7));
        window.fbq('track', 'Lead', {
            content_name: 'Primeira Conexão de Plataforma',
            content_category: 'Onboarding',
            value: 0.00,
            currency: 'BRL'
        }, __assign({ eventID: eventID }, hashedData));
        /* console.log('✅ Facebook Pixel: Lead event tracked', {
          eventID,
          parametros: Object.keys(hashedData)
        });*/
    }
};
/**
 * 🎯 DISPARA CONVERSÃO NO MOMENTO QUE USUÁRIO INCLUI PRIMEIRO CLIENTE
 * (Complementar à conversão de primeira conexão)
 */
export var trackFirstClientCreated = function (userData) {
    if (typeof window === 'undefined')
        return;
    var hashedData = {};
    if (userData.email)
        hashedData.em = hashData(userData.email);
    if (userData.firstName)
        hashedData.fn = hashData(userData.firstName);
    if (userData.lastName)
        hashedData.ln = hashData(userData.lastName);
    if (userData.userId)
        hashedData.external_id = userData.userId;
    hashedData.country = hashData('br');
    // GTM DataLayer
    if (window.dataLayer) {
        window.dataLayer.push({
            event: 'firstClientCreated',
            user_data: hashedData,
            event_category: 'conversion',
            event_label: 'primeiro_cliente',
            value: 0.00,
            currency: 'BRL'
        });
        // console.log('✅ GTM DataLayer: firstClientCreated pushed');
    }
    // Facebook Pixel (fallback)
    if (window.fbq) {
        window.fbq('track', 'AddToCart', {
            content_name: 'Primeiro Cliente Criado',
            content_category: 'Onboarding',
            value: 0.00,
            currency: 'BRL'
        }, hashedData);
        // console.log('✅ Facebook Pixel: AddToCart (primeiro cliente) tracked');
    }
};
